module.exports = __webpack_public_path__ + "static/media/rellika.602e12b4.jpeg";